export default __webpack_public_path__ + "static/media/disclaimer.eab4fc2e.md";